<template>
	<section>
		<footer class="footer_comm" id="footer_comm">
			<section class="footerBox">
				<div class="footer_t">
					<div class="ft_item ft_item_logo"><img src="//frontend.originoo.com/originoo_web/logo/logo.png" /></div>
					<div class="ft_item ft_item_product">
						<div class="ft_item_title">我们的产品</div>
						<div class="ft_item_item">
							<a href="//www.originoo.com">创意图片</a>
						</div>
						<div class="ft_item_item">
							<a href="//www.originoo.com?vector">设计素材</a>
						</div>
						<div class="ft_item_item">
							<!--<a href="//www.originoo.com/premium">高端图片</a>-->
							<router-link to="/premium">高端图片</router-link>
						</div>
						<div class="ft_item_item">
							<!--<a href="//www.originoo.com/video">创意视频</a>-->
							<router-link to="/movie">创意视频</router-link>
						</div>
						<div class="ft_item_item">
							<!--<a href="//www.originoo.com/yunpai">照片直播</a>-->
							<router-link to="/yunpai">照片直播</router-link>
						</div>
					</div>
					<div class="ft_item ft_item_companyinfo">
						<div class="ft_item_title">公司信息</div>
						<div class="ft_item_item">
							<!--<a href="//www.originoo.com/ws/p.aboutus.php">关于我们</a>-->
							<router-link to="/aboutUs">关于我们</router-link>
						</div>
						<div class="ft_item_item">
							<!--<a href="//www.originoo.com/ws/p.concatus.php">联系方式</a>-->

							<router-link to="/contact">联系方式</router-link>
						</div>
						<div class="ft_item_item">
							<a @click.stop="toGTPT">签约供图</a>
						</div>
					</div>
					<div class="ft_item ft_item_resource">
						<div class="ft_item_title">资源</div>

						<div class="ft_item_item">
							<a href="/commonproblem">常见问题</a>
						</div>
						<div class="ft_item_item">
							<a href="/clause">使用条款</a>
						</div>
						<div class="ft_item_item">
							<a href="/agreement">授权协议</a>
						</div>
						<div class="ft_item_item">
							<!--<a href="//www.originoo.com/ws/p.sitemap.php">网站地图</a>-->

							<router-link to="/websiteMap">网站地图</router-link>
						</div>
					</div>
					<div class="ft_item ft_item_friendshiplink">
						<div href="" class="ft_item_title">友情链接</div>

						<div class="ft_item_item">
							<a href="//www.chuangkit.com/" target="_blank">平面设计</a>
						</div>
						<div class="ft_item_item">
							<a href="//www.xiusheji.com/" target="_blank">秀设计</a>
						</div>
						<div class="ft_item_item">
							<a href="//www.fotor.com.cn/sheji/haibao" target="_blank">海报设计</a>
						</div>
						<div class="ft_item_item">
							<!--<a href="//www.originoo.com/ws/p.friendshiplink.php">更多 ></a>-->
						</div>
					</div>
					<div class="ft_item ft_item_contact">
						<div class="ft_item_title">联系方式</div>
						<div class="ft_item_contact_phoneNum">4000-365-890</div>
					</div>
					<div class="ft_item ft_item_worktime">
						<div class="ft_item_title">工作时间</div>
						<div class="ft_item_item">周一~周五 9:00-18:00</div>
					</div>
					<div class="ft_item ft_item_socialmedia">
						<div class="ft_item_title">社交媒体</div>
						<div class="socialmedia_item">
							<div class="socialmedia_item_title">锐景创意公众号</div>
							<img src="//frontend.originoo.com/missioncenter/d/qr_gzh.jpg" />
						</div>
						<div class="socialmedia_item">
							<div class="socialmedia_item_title">锐景创意服务号</div>
							<img src="//frontend.originoo.com/missioncenter/d/qr_fwh.jpg" />
						</div>
						<div class="socialmedia_item">
							<div class="socialmedia_item_title">锐景云拍公众号</div>
							<img src="//frontend.originoo.com/missioncenter/d/qr_ypgzh.jpg" />
						</div>
					</div>
				</div>

				<div class="footer_b">
					<div class="footer_bt">
						<div class="footer_b_item">
							<a href="//weibo.com/u/5978805004?from=myfollow_all#_0" target="_blank">微博</a>
						</div>
						<div class="footer_b_item">
							<a href="//huaban.com/originoo/" target="_blank">花瓣</a>
						</div>
						<div class="footer_b_item">
							<a href="//www.instagram.com/originoostock/" target="_blank">Instagram</a>
						</div>
					</div>
					<div class="footer_bm">
						<div class="footer_b_item">苏州锐景文化科技有限公司 Copyright© 2016 - {{ new Date().getFullYear() }} All rights reserved.</div>
					</div>
					<div class="footer_bb">
						<div class="footer_b_item">
							<a href="https://beian.miit.gov.cn/" target="_blank">备案号&nbsp;&nbsp;&nbsp;苏ICP备16066571号-7</a>
						</div>
						<div class="footer_b_item">增值业务经营许可证&nbsp;&nbsp;&nbsp;苏B2-20180385</div>
						<div class="footer_b_item">
							<a href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002002371" target="_blank">
								<img src="//frontend.originoo.com/missioncenter/d/footer_jh.png" /> 苏公网安备&nbsp;&nbsp;&nbsp;32059002002371号
							</a>
						</div>
						<div class="footer_b_item">举报邮箱&nbsp;&nbsp;&nbsp;jubao@originoo.com</div>
						<div class="footer_b_item">举报电话&nbsp;&nbsp;&nbsp;0512-81660580</div>
					</div>
				</div>
			</section>
		</footer>
	</section>
</template>

<script>
	export default {
		data() {
			return {}
		},
		created() {

		},
		mounted() {

		},
		methods: {

		}

	}
</script>

<style scoped>
	.footer_comm {
		background: #353535;
		padding: 60px 40px;
		color: #ffffff;
		box-sizing: border-box;
	}
	
	.footer_comm .footerBox {
		width: 1200px;
		margin: 0 auto;
	}
	
	.footer_comm .footer_t {
		height: 300px;
		font-size: 0;
	}
	
	.footer_comm .ft_item {
		display: inline-block;
		vertical-align: top;
		color: #b2b2b2;
	}
	
	.footer_comm .ft_item_title {
		height: 20px;
		font-size: 14px;
		line-height: 20px;
		margin-bottom: 15px;
	}
	
	.footer_comm .ft_item_item {
		height: 17px;
		font-size: 12px;
		color: #b2b2b2;
		line-height: 17px;
		margin-bottom: 10px;
	}
	
	.footer_comm .ft_item_item a {
		color: #b2b2b2;
	}
	
	.footer_comm .ft_item.ft_item_logo {
		width: 157px;
	}
	
	.footer_comm .ft_item.ft_item_logo img {
		width: 87px;
		height: 20px;
	}
	
	.footer_comm .ft_item.ft_item_product {
		width: 130px;
	}
	
	.footer_comm .ft_item.ft_item_companyinfo {
		width: 116px;
	}
	
	.footer_comm .ft_item.ft_item_resource {
		width: 108px;
	}
	
	.footer_comm .ft_item.ft_item_friendshiplink {
		width: 132px;
	}
	
	.footer_comm .ft_item.ft_item_contact {
		width: 205px;
	}
	
	.footer_comm .ft_item.ft_item_contact .ft_item_title {
		margin-bottom: 10px;
	}
	
	.footer_comm .ft_item.ft_item_contact .ft_item_contact_phoneNum {
		color: #ff7545;
		font-size: 20px;
		line-height: 28px;
	}
	
	.footer_comm .ft_item.ft_item_worktime {
		width: 180px;
	}
	
	.footer_comm .ft_item.ft_item_socialmedia {
		width: 172px;
	}
	
	.footer_comm .ft_item.ft_item_socialmedia .ft_item_title {
		margin-bottom: 10px;
	}
	
	.footer_comm .ft_item.ft_item_socialmedia .socialmedia_item {
		border-radius: 20px;
		border: 1px solid #b2b2b2;
		padding: 4px 16px;
		width: 173px;
		height: 30px;
		margin-bottom: 10px;
		box-sizing: border-box;
	}
	
	.footer_comm .ft_item.ft_item_socialmedia .socialmedia_item .socialmedia_item_title {
		width: 84px;
		height: 22px;
		font-size: 12px;
		color: #b2b2b2;
		line-height: 22px;
		display: inline-block;
		vertical-align: top;
	}
	
	.footer_comm .ft_item.ft_item_socialmedia .socialmedia_item img {
		width: 22px;
		height: 22px;
		float: right;
	}
	
	.footer_comm .ft_item.ft_item_socialmedia .socialmedia_item:hover {
		padding: 7px 16px 15px;
		height: 188px;
	}
	
	.footer_comm .ft_item.ft_item_socialmedia .socialmedia_item:hover .socialmedia_item_title {
		width: 100%;
		margin-bottom: 7px;
		height: 17px;
		font-size: 12px;
		color: #b2b2b2;
		line-height: 17px;
		display: block;
		text-align: center;
	}
	
	.footer_comm .ft_item.ft_item_socialmedia .socialmedia_item:hover img {
		width: 142px;
		height: 142px;
		clear: all;
	}
	
	.footer_comm .footer_b {
		padding-top: 15px;
		border-top: 2px solid #2a2a2a;
	}
	
	.footer_comm .footer_b .footer_b_item {
		height: 20px;
		font-size: 12px;
		color: #b2b2b2;
		line-height: 20px;
		vertical-align: top;
		display: inline-block;
		margin-right: 44px;
	}
	
	.footer_comm .footer_b .footer_b_item a {
		color: #b2b2b2;
	}
	
	.footer_comm .footer_b .footer_b_item a img {
		width: 20px;
		height: 20px;
		vertical-align: -5px;
	}
	
	.footer_comm .footer_b .footer_bt {}
	
	.footer_comm .footer_b .footer_bm {
		margin-top: 15px;
	}
	
	.footer_comm .footer_b .footer_bb {
		margin-top: 6px;
	}
	
	.footer_comm.free .ft_item_contact_phoneNum {
		/*color: #57D6D6 !important;*/
	}
	
	.footer_comm.grade .ft_item_contact_phoneNum {
		color: #deba7e !important;
	}
	
	.footer_comm.main {}
</style>


// WEBPACK FOOTER //
// src/config/vue/footer.vue